// extracted by extract-css-chunks-webpack-plugin
module.exports = {"lx_list":"lx_list-2Ftf8ug6 clearfix"};